<script lang="ts">
  import { isNonEmptyArray } from '#app/lib/boolean_tests'
  import type { EntitiesSortFunction } from '#app/types/entity'
  import type { WorkEditionFilters } from '#entities/components/lib/editions_list_actions_helpers'
  import type { SerializedEntitiesByUris, SerializedEntity } from '#entities/lib/entities'
  import type { SerializedItemWithUserData } from '#inventory/lib/items'
  import { I18n } from '#user/lib/i18n'
  import { mainUser } from '#user/lib/main_user'
  import EditionCreation from './edition_creation.svelte'
  import EditionsListActions from './editions_list_actions.svelte'
  import EntitiesList from './entities_list.svelte'
  import type { ItemsByEditions } from './edition_actions.svelte'

  let {
    hasSomeInitialEditions = false,
    editions,
    publishersByUris,
    parentEntity,
    allEditions,
    waitingForItems,
    itemsByEditions,
    workEditionFilters = $bindable(),
    entitiesSortFunction = $bindable(),
  }: {
    hasSomeInitialEditions?: boolean
    editions: SerializedEntity[]
    publishersByUris: SerializedEntitiesByUris
    parentEntity: SerializedEntity
    allEditions: SerializedEntity[]
    waitingForItems: Promise<SerializedItemWithUserData[]>
    itemsByEditions: ItemsByEditions
    workEditionFilters: WorkEditionFilters
    entitiesSortFunction: EntitiesSortFunction
  } = $props()
</script>

<div class="editions-section">
  <div class="editions-list-title">
    <h5>
      {I18n('editions')}
    </h5>
    {#if isNonEmptyArray(allEditions)}
      <span
        class="counter"
        title={I18n('all_editions_count', { smart_count: allEditions.length })}
      >
        {allEditions.length}
      </span>
    {/if}
  </div>
  {#if hasSomeInitialEditions}
    {#if allEditions.length > 1}
      <EditionsListActions
        {allEditions}
        {waitingForItems}
        bind:workEditionFilters
        bind:entitiesSortFunction
        displayedEditionsCount={editions.length}
      />
    {/if}
    <EntitiesList
      entities={editions}
      relatedEntities={publishersByUris}
      {itemsByEditions}
    />
  {:else}
    <div class="no-edition-wrapper">
      {I18n('no editions found')}
    </div>
  {/if}
  {#if mainUser}
    <EditionCreation
      work={parentEntity}
      editions={allEditions}
    />
  {/if}
</div>

<style lang="scss">
  @import "general/scss/utils";

  .editions-section{
    @include display-flex(column, center);
    @include radius;
    padding: 0.5em;
    inline-size: 100%;
    background-color: $off-white;
  }
  .editions-list-title{
    @include display-flex(row, center, center);
    margin-block-end: 0.5em;
    h5{
      @include sans-serif;
      margin-block-end: 0;
    }
    .counter{
      line-height: 1em;
      margin: 0 0.5em;
      padding: 0.2em 0.5em;
      background-color: white;
      @include radius;
    }
  }
  .no-edition-wrapper{
    @include display-flex(row, center, center);
    color: $grey;
  }

  /* Large screens */
  @media screen and (width >= $small-screen){
    .editions-section{
      padding: 1em;
    }
  }
</style>
